/**
 * @description Возвращает iso строку, приравнивая timezoneOffset к нулю.
 * Например, такой вызов вернет неверную дату new Date('Sat Jan 01 1965 00:00:00 GMT+0400 (Volgograd Standard Time)').toISOString() => 1964-12-31T20:00:00.000Z
 * То есть тут он применяет timezoneOffset и возвращает другую дату
 * В этой функции вычищается информация о timezoneOffset, чтобы форматировать корректно в iso формат дату
 * @param {string|Date} date
 * @returns
 */
export default (date) => {
  const dateStr = new Date(date).toString();

  return new Date(dateStr.replace(/(GMT)\+(\d+)/, '$1+0000')).toISOString();
}
